// extracted by mini-css-extract-plugin
module.exports = {"container":"Program_container__3wumi","wrapper":"Program_wrapper__3umKP","infolog1--text":"Program_infolog1--text__2OH77","section":"Program_section__niQvf"};